const nav = document.querySelector("nav.nav");
const burger = document.querySelector(".header-hamburger__button");
const header = document.querySelector(".header__container");

const closeNav = () => {
    nav.style.transform = "translateX(100%)";
    header.classList.remove("nav--open");
    burger.setAttribute("aria-expanded", false);
}
burger.addEventListener("click", () => {
    if (burger.getAttribute("aria-expanded") === "false") {
        nav.style.transform = "translateX(0)";
        header.classList.add("nav--open");
        burger.setAttribute("aria-expanded", true);
    } else {
        closeNav();
    }
});

if (document.querySelector("body").classList.contains("single-work")) {
    window.addEventListener("scroll", () => {
        if (window.scrollY > 10) {
            header.classList.add("header--scrolled");
        } else {
            header.classList.remove("header--scrolled");
        }
    })
}

nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeNav);
})